import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import dream11 from '@assets/images/icon/dream11-icon.png'
import eleWickets from '@assets/images/icon/11wickets-icon.png'
import howzat from '@assets/images/icon/howzat-logo.png'
// import gamezy from '@assets/images/icon/gamezy-icon.png'
// import my11circle from '@assets/images/icon/my-11circle-icon.png'
import arrow from '@assets/images/icon/right-arrow.svg'
import useTranslation from 'next-translate/useTranslation'
import { gameType } from '@utils'
import CustomLink from '@shared/components/customLink'

const MyImage = dynamic(() => import('@shared/components/myImage'))

const CricPrediction = ({ data }) => {
  const { t } = useTranslation()
  const platform = {
    de: {
      css: styles.dream11,
      logo: dream11
    },
    ew: {
      css: styles.eleWickets,
      logo: eleWickets
    },
    h: {
      css: styles.howzat,
      logo: howzat
    }
  }
  return (
    <>
      <section className={`${styles.cricPrediction} mb-3 mb-md-4 br-lg`}>
        <p className="big-text fw-bold text-center text-uppercase">{t('common:CricPrediction')}</p>
        <Row className="justify-content-center">
          {data?.map((game) => {
            const { css, logo } = platform?.[game.ePlatformType]
            return (
              <React.Fragment key={game._id}>
                <Col sm={6}>
                  <CustomLink
                    className={`${styles.predictionBtn} ${css} font-semi text-uppercase d-flex align-items-center justify-content-between br-sm`}
                    href={`/${game?.oSeo?.sSlug}` || ''}
                    prefetch={false}
                  >
                    <>
                      <div className={`${styles.icon}`}>
                        <MyImage src={logo} alt={gameType(game.ePlatformType)} />
                      </div>
                      {gameType(game.ePlatformType)}
                      <div className={`${styles.arrow}`}>
                        <MyImage src={arrow} alt={gameType(game.ePlatformType)} />
                      </div>
                    </>
                  </CustomLink>
                </Col>
              </React.Fragment>
            )
          })}
        </Row>
      </section>
    </>
  )
}

CricPrediction.propTypes = {
  data: PropTypes.array
}

export default CricPrediction
